import { api } from "./index";

// Ativar ou desativar MFA para o utilizador autenticado
export const setMfaEnabled = async (
  userId: number,
  enabled: boolean,
  token: string
): Promise<{ message: string; mfa_enabled: boolean }> => {
  const response = await api.patch(
    `/users/${userId}/mfa`,
    { enabled },
    {
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
